import React from 'react';
import TextField from 'material-ui/TextField';
import ShortForm from './ShortForm';
import { Link } from "react-router-dom";
import Page from './Page';

export default class Login extends Page {

	constructor(...args){
		super(...args);
		window.app.loginForm.username = '';
		window.app.loginForm.password = '';
	}

	render(){
		return(
			<ShortForm
				label="LOGIN"
				submitButton={{label:"LOG IN", onClick:() => { window.app.loginForm.submit()}}}
				waiting={window.app.loginForm.loading}
				errorMessage={window.app.loginForm.errorMessage}
				>
				<TextField
					label="Email"
					id="username"
					defaultValue={window.app.loginForm.username}
					onChange={ e => window.app.loginForm.username = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				<TextField
					label="Password"
					type="password"
					id="password"
					defaultValue={window.app.loginForm.password}
					onChange={ e => window.app.loginForm.password = e.currentTarget.value }
					margin="normal"
					fullWidth/>
				
				<div style={{textAlign:"right", fontSize:'13px'}}>
					<Link to="/change-password">FORGOT YOUR PASSWORD?</Link>
				</div>

			</ShortForm>
		);	
	}
}





// WEBPACK FOOTER //
// ./src/components/Login.js